import { createContext } from 'react';
import type { SessionToken } from './types';

export interface SessionContextValue {
  token: SessionToken | null;
  gameId: string | null;
  /** embed_key from the iframe URL — anonymous embed mode when set. */
  embedKey: string | null;
  /** Stable identity — always returns the CURRENT token (live view for
   *  in-flight flows; no client re-creation on token adoption). */
  getToken: () => SessionToken | null;
  /** Stable identity — persists the token to sessionStorage and updates state. */
  adoptToken: (t: SessionToken) => void;
  /** Stable identity — clears sessionStorage and resets state to null. */
  dropToken: () => void;
}

export const SessionContext = createContext<SessionContextValue | null>(null);
